/* pp-home-promo.js — carrusel de la tarjeta grande del banner del inicio.
   Lo carga pp-home-promo.liquid SOLO cuando hay más de una promo vigente.
   - Una tarjeta a la vez, puntos abajo, deslizar con el dedo.
   - Autoplay (data-autoplay segundos); pausa al pasar el mouse, al enfocar
     con teclado y con la pestaña oculta. Sin autoplay con menos movimiento.
   - Las tarjetas que no se ven quedan aria-hidden y fuera del tab.
   - En el Personalizador, al elegir un bloque salta a su tarjeta. */
(function () {
  function init(root) {
    if (!root || root.dataset.ppReady) return;
    root.dataset.ppReady = '1';

    var track = root.querySelector('[data-ppb-tr]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ppb-dot]'));
    if (slides.length < 2) return;

    var i = 0;
    var timer = null;
    var paused = false;
    var secs = parseInt(root.dataset.autoplay, 10) || 5;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      slides.forEach(function (s, k) {
        var on = k === i;
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (s.tagName === 'A') {
          if (on) s.removeAttribute('tabindex'); else s.setAttribute('tabindex', '-1');
        }
      });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-on', k === i);
        if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
      // El punto activo va oscuro sobre fondo claro y blanco sobre el azul.
      var claro = slides[i].classList.contains('ppb__main--temporada');
      root.classList.toggle('ppb__car--claro', claro);
    }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (reduce) return;
      timer = setInterval(function () { if (!paused && !document.hidden) go(i + 1); }, secs * 1000);
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.dataset.ppbDot, 10)); start(); });
    });

    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });

    // Deslizar con dedo o mouse; si hubo arrastre, el click que sigue no
    // abre la liga de la tarjeta.
    var sx = null, sy = null, dragged = false;
    track.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; dragged = false; });
    track.addEventListener('pointerup', function (e) {
      if (sx === null) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        dragged = true;
        go(i + (dx < 0 ? 1 : -1));
        start();
      }
      sx = null;
    });
    track.addEventListener('click', function (e) {
      if (dragged) { e.preventDefault(); dragged = false; }
    }, true);

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(i - 1); start(); }
      if (e.key === 'ArrowRight') { go(i + 1); start(); }
    });

    document.addEventListener('shopify:block:select', function (e) {
      var k = slides.indexOf(e.target);
      if (k > -1) { go(k); paused = true; }
    });
    document.addEventListener('shopify:block:deselect', function () { paused = false; });

    go(0);
    start();
  }

  function boot() {
    document.querySelectorAll('[data-ppb-car]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
